<app-page-application [isLoaded]="isLoaded">
  <router-outlet></router-outlet>
</app-page-application>

